export { default } from './Participation.component';
